// ======================================================================
// File Name       : service
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { MIN_DATE, MAX_DATE, parseDateForDetail } from '../utils/index';
import { SERVICE_SEARCH, SERVICE_RECEIVE_ENTERPRISE_STRUCTURE } from '../constants/ActionTypes';
import * as ServiceActionTypes from '../constants/actionTypes/service';
import { mapUserSecernIdWithGroupName } from '../utils/UserUtils';
import { HYPHEN } from '../constants';

const initialState = {
  serviceInfo: {
    recordNum: null,
    serviceList: [],
  },
  enterpriseInfo: {
    byCd: {},
    allCds: [],
  },
  serviceNotice: {
    bySecernIds: {},
    allSecernIds: [],
  },
  edittingUsers: {
    bySecernIds: {},
    allSecernIds: [],
  },
  serviceNoticeDetail: {},
  serviceDetailUserList: [],
  serviceNotiRecordNum: 0,
  storedUserList: {},
  userListDialogRecordNum: 0,
  allUserByGroup: [],
  videoSpeedArr: [
    { speed: '0.5', isChecked: false }, { speed: '0.75', isChecked: false },
    { speed: '1.0', isChecked: true }, { speed: '1.25', isChecked: false },
    { speed: '1.5', isChecked: false }, { speed: '1.75', isChecked: false },
    { speed: '2.0', isChecked: false }, { speed: '3.0', isChecked: false },
    { speed: '4.0', isChecked: false },
  ],
  isUsedVideoSpeedSetting: true,
};

export default function service(state = initialState, action) {
  switch (action.type) {
    case SERVICE_SEARCH: {
      const { serviceInfo } = action;
      const videoSpeedArrUpdate = [...state.videoSpeedArr];
      const isUsedVideoSpeedSetting = true;
      // incase of editting
      if (parseInt(serviceInfo.recordNum, 10) === 1) {
        let videoSpeedSetting = '';
        if (serviceInfo.serviceList[0]) {
          videoSpeedSetting = serviceInfo.serviceList[0].usageSettingInfo.videoSpeedSetting;
        }
        const videoSpeedSettingResult = videoSpeedSetting ? videoSpeedSetting.split(HYPHEN) : [];
        const isManySpeedUsed = videoSpeedSettingResult.length > 0;
        if (isManySpeedUsed) {
          videoSpeedArrUpdate.map((value) => {
            if (parseInt(videoSpeedSettingResult.indexOf(value.speed), 10) > -1) {
              value.isChecked = true;
            }
          });
        }
      }

      return { ...state, ...{ serviceInfo }, videoSpeedArr: videoSpeedArrUpdate, isUsedVideoSpeedSetting };
    }
    case SERVICE_RECEIVE_ENTERPRISE_STRUCTURE: {
      const { enterpriseList } = action;
      const enterpriseInfo = enterpriseList && enterpriseList.length > 0 && enterpriseList.reduce(
        (acc, cur) => {
          acc.byCd[cur.enterpriseCd] = cur;
          acc.allCds.push(cur.enterpriseCd);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      const { serviceInfo } = state;
      const { serviceList } = serviceInfo;
      serviceList &&
        serviceList.length > 0 &&
        serviceList.forEach((serviceItem) => {
          if (enterpriseInfo.byCd[serviceItem.enterpriseCd]) {
            serviceItem.enterpriseName =
              enterpriseInfo.byCd[serviceItem.enterpriseCd].enterpriseName;
          }
        });
      return { ...state, ...{ serviceInfo }, ...{ enterpriseList } };
    }
    case ServiceActionTypes.RECEIVE_SERVICE_NOTIFICATION_LIST: {
      const { searchResult } = action;
      let serviceNotice = {
        bySecernIds: {},
        allSecernIds: [],
      };
      let serviceNotiRecordNum = 0;
      if (searchResult && searchResult.noticeList && searchResult.noticeList.length) {
        serviceNotice = searchResult.noticeList.reduce(
          (acc, cur) => {
            if (cur.noticeSecernId) {
              acc.allSecernIds.push(cur.noticeSecernId);
              acc.bySecernIds[cur.noticeSecernId] = cur;
            }
            return acc;
          },
          {
            allSecernIds: [],
            bySecernIds: {},
          },
        );
        serviceNotiRecordNum = searchResult.recordNum || 0;
      }
      return {
        ...state,
        serviceNotice,
        serviceNotiRecordNum,
      };
    }
    case ServiceActionTypes.RECEIVE_SERVICE_NOTICE_DETAIL: {
      const { searchResult, userListToStore, groupRelationList, groupInfo } = action;
      let newUserList = [];
      if (userListToStore) {
        newUserList = userListToStore.reduce((acc, cur) => {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            groupRelationList,
            groupInfo,
          );
          acc.push(cur);
          return acc;
        }, []);
      }
      let serviceNoticeDetail = {};
      if (searchResult && searchResult.noticeList && searchResult.noticeList.length) {
        serviceNoticeDetail = searchResult.noticeList[0];
      }
      return {
        ...state,
        serviceNoticeDetail,
        serviceDetailUserList: newUserList,
        groupRelationList,
      };
    }
    case ServiceActionTypes.INIT_SERVICE_NOTICE_DETAIL: {
      const { searchResult, userListToStore, groupRelationList, groupInfo } = action;
      let newUserList = [];
      const edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      if (userListToStore) {
        newUserList = userListToStore.reduce((acc, cur) => {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            groupRelationList,
            groupInfo,
          );
          edittingUsers.bySecernIds[cur.userSecernId] = cur;
          edittingUsers.allSecernIds.push(cur.userSecernId);
          acc.push(cur);
          return acc;
        }, []);
      }
      let serviceNoticeDetail = {};
      if (searchResult && searchResult.noticeList && searchResult.noticeList.length) {
        serviceNoticeDetail = searchResult.noticeList[0];
      }
      const formInitialValues = { ...serviceNoticeDetail };
      formInitialValues.publicDateFrom = parseDateForDetail(formInitialValues.publicDateFrom);
      formInitialValues.publicDateTo = parseDateForDetail(formInitialValues.publicDateTo);
      if (!formInitialValues.publicDateFrom && !formInitialValues.publicDateTo) {
        formInitialValues.releasePeriod = 0;
      } else {
        formInitialValues.releasePeriod = 1;
        formInitialValues.publicDateFrom &&
          (formInitialValues.publicDateFrom = moment(formInitialValues.publicDateFrom));
        formInitialValues.publicDateTo &&
          (formInitialValues.publicDateTo = moment(formInitialValues.publicDateTo));
      }
      return {
        ...state,
        formInitialValues,
        serviceNoticeDetail,
        serviceDetailUserList: newUserList,
        edittingUsers,
        groupRelationList,
      };
    }
    case ServiceActionTypes.STORE_SERVICE_USER_LIST: {
      const { userSearchResult, groupRelationList, groupInfo } = action;
      const { storedUserList } = state;
      let newUserList = [];
      let userListDialogRecordNum = 0;
      if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
        const { userList } = userSearchResult;
        newUserList = userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            cur.groupNames = mapUserSecernIdWithGroupName(
              cur.userSecernId,
              groupRelationList,
              groupInfo,
            );
            acc.push(cur);
            if (!storedUserList[cur.userSecernId]) {
              storedUserList[cur.userSecernId] = cur;
            }
          }
          return acc;
        }, []);
        userListDialogRecordNum = userSearchResult.recordNum || 0;
      }
      return {
        ...state,
        storedUserList,
        userList: newUserList,
        userListDialogRecordNum,
      };
    }
    case ServiceActionTypes.ADD_SERVICE_USER_TO_LIST_BY_GROUPS: {
      const { userListToAdd, groupRelationList, groupInfo } = action;
      const { storedUserList } = state;
      let edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      if (userListToAdd && userListToAdd.length) {
        edittingUsers = userListToAdd.reduce(
          (acc, cur) => {
            if (cur.userSecernId) {
              cur.groupNames = mapUserSecernIdWithGroupName(
                cur.userSecernId,
                groupRelationList,
                groupInfo,
              );

              if (acc.allSecernIds.indexOf(cur.userSecernId)) {
                acc.allSecernIds.push(cur.userSecernId);
              }

              if (!acc.bySecernIds[cur.userSecernId]) {
                acc.bySecernIds[cur.userSecernId] = cur;
              }

              if (!storedUserList[cur.userSecernId]) {
                storedUserList[cur.userSecernId] = cur;
              }
            }
            return acc;
          },
          {
            bySecernIds: {},
            allSecernIds: [],
          },
        );
      }
      return {
        ...state,
        edittingUsers,
        storedUserList,
      };
    }
    case ServiceActionTypes.ADD_SERVICE_USER_TO_LIST: {
      const { userListToAdd } = action;
      const { storedUserList } = state;
      let edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      if (userListToAdd && storedUserList) {
        edittingUsers = userListToAdd.reduce(
          (acc, cur) => {
            if (storedUserList[cur]) {
              acc.bySecernIds[cur] = storedUserList[cur];
              acc.allSecernIds.push(cur);
            }
            return acc;
          },
          {
            bySecernIds: {},
            allSecernIds: [],
          },
        );
      }
      return {
        ...state,
        edittingUsers,
      };
    }
    case ServiceActionTypes.REMOVE_SERVICE_USER_FROM_LIST: {
      const { userSecernId } = action;
      const { edittingUsers } = state;
      if (userSecernId && edittingUsers) {
        if (edittingUsers.bySecernIds && edittingUsers.bySecernIds[userSecernId]) {
          delete edittingUsers.bySecernIds[userSecernId];
        }
        if (edittingUsers.allSecernIds) {
          const pos = edittingUsers.allSecernIds.indexOf(userSecernId);
          if (pos > -1) {
            edittingUsers.allSecernIds.splice(pos, 1);
          }
        }
      }
      return {
        ...state,
        edittingUsers,
      };
    }
    case ServiceActionTypes.RESET_EDITING_SERVICE_USERS: {
      const edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      const formInitialValues = {};
      return {
        ...state,
        edittingUsers,
        formInitialValues,
      };
    }
    case ServiceActionTypes.ALL_USER_RECEIVED: {
      const allUserByGroupNew = [...state.allUserByGroup];
      const { data } = action;
      if (data && data.userList) {
        data.userList.reduce((acc, cur) => {
          if (cur && cur.userSecernId) {
            const pos = allUserByGroupNew.findIndex(e => e.userSecernId === cur.userSecernId);
            if (pos < 0) {
              acc.push(cur);
            }
          }
          return acc;
        }, allUserByGroupNew);
      }
      return {
        ...state,
        allUserByGroup: allUserByGroupNew,
      };
    }
    case ServiceActionTypes.REMOVED_ALL_USER_RECEIVED: {
      return {
        ...state,
        allUserByGroup: [],
      };
    }
    case ServiceActionTypes.INITIALIZE_VIDEO_SPEED_OPTIONS: {
      const { videoSpeedArr } = action;
      return {
        ...state,
        videoSpeedArr,
      };
    }
    case ServiceActionTypes.UPDATE_VIDEO_SPEED_USAGE: {
      const { isUsed } = action;
      return {
        ...state,
        isUsedVideoSpeedSetting: isUsed,
      };
    }
    case ServiceActionTypes.RESET_SERVICE_NOTICE_DETAIL: {
      const { serviceNoticeDetail } = initialState;
      return {
        ...state,
        serviceNoticeDetail,
      };
    }
    default: {
      const { serviceInfo } = initialState;
      return {
        ...state,
        serviceInfo,
      };
    }
  }
}
